<script setup lang="ts">
import { TriangleExclamation, CheckCircle } from '@ui/icons/filled';
import Icon from '@ui/components/icons/Icon.vue';
import { MessageVariety } from '@ui/styles';

const props = withDefaults(defineProps<{
  variety?: MessageVariety;
  message?: string | [string, ...unknown[]];
}>(), {
  variety: MessageVariety.Default,
  message: '',
});

const icon = computed(() => {
  switch (props.variety) {
    case MessageVariety.Error: return TriangleExclamation;
    case MessageVariety.Success: return CheckCircle;
    default: return '';
  }
})
</script>

<template lang="pug">
Transition
  .message.min-h-18.flex-unset-center.row-4.p-l-12.typ-12-400(v-if="message" :class="{[variety]: true}")
    Icon.size-16(v-if="icon" :name="icon")
    | {{ Array.isArray(message) ? $t(...message) : $t(message) }}
</template>

<style scoped lang="scss">
@use "@ui/styles/scss/colors" as *;

.message {
  &.default {
    color: $color-gray-500;
  }

  &.error {
    color: $color-coral-600;
  }

  &.success {
    color: #2CB061;
  }

  &.mark {
    color: $color-gray-800;
    justify-content: end;
  }
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s ease-in-out;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>